import { render, staticRenderFns } from "./BuildSiteSubmit.vue?vue&type=template&id=651c0b7e&scoped=true"
import script from "./BuildSiteSubmit.vue?vue&type=script&lang=js"
export * from "./BuildSiteSubmit.vue?vue&type=script&lang=js"
import style0 from "./BuildSiteSubmit.vue?vue&type=style&index=0&id=651c0b7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651c0b7e",
  null
  
)

export default component.exports